import { get } from "lodash"

import { EXCHANGE, SECURITY_TYPE } from "config/const"
import { APIResponse } from "redux/apis/types"
import { Dispatch } from "redux"
import { API_MESSAGE } from "./Push"

import APIs from "redux/apis"
import store from "redux/store"
import { checkIsSp } from "utils/util"
import { setToastData } from "./Toast"
import { UserStorage } from "utils/userStorage"

export type ReduxSymbolDetailActionType = {
  type?: string
  data?: object
  show?: boolean
  tab?: number
}

export type ReduxSymbolDetailStateType = {
  loading: boolean
  show: boolean
  callRegulation: boolean
  refresh: boolean
  tab: number
  data: {
    Result?: number
    Message?: null | string
    Symbol?: APIResponse.Res
  }
}

/************************************
 * ACTION TYPE
 ************************************/
export const REDUX_SYMBOL_DETAIL_SHOW_SYMBOL = "REDUX_SYMBOL_DETAIL_SHOW_SYMBOL"
export const REDUX_SYMBOL_DETAIL_HIDE_SYMBOL = "REDUX_SYMBOL_DETAIL_HIDE_SYMBOL"
export const REDUX_SYMBOL_DETAIL_CHANGE_TAB = "REDUX_SYMBOL_DETAIL_CHANGE_TAB"
export const REDUX_SYMBOL_DETAIL_CHANGE_SYMBOL =
  "REDUX_SYMBOL_DETAIL_CHANGE_SYMBOL"
export const REDUX_SYMBOL_DETAIL_REFRESH = "REDUX_SYMBOL_DETAIL_REFRESH"
export const REDUX_SYMBOL_DETAIL_LOADING = "REDUX_SYMBOL_DETAIL_LOADING"
export const REDUX_SYMBOL_DETAIL_CALL_REGULATION =
  "REDUX_SYMBOL_DETAIL_CALL_REGULATION"

/************************************
 * ACTIONS
 ************************************/
export const showSymbol: (
  data: APIResponse.Res,
  tab?: number,
  callRegulation?: boolean,
  refresh?: boolean
) => any = (data, tab, callRegulation, refresh) => {
  const isSymbol = !!get(data, "Symbol")
  const isExchange = !!get(data, "Exchange")
  const isSecurityType = !!get(data, "SecurityType")
  return async (dispatch: Dispatch) => {
    if (!isSymbol || !isExchange || !isSecurityType) return
    //二重リクエスト防止
    const isLoading = store.getState().symbolDetail.loading
    if (!isLoading) {
      dispatch({
        type: REDUX_SYMBOL_DETAIL_LOADING,
      })
      const symbolData: any = await APIs.SymbolDetail.SymbolDetail({
        Symbol: get(data, "Symbol"),
        Exchange: get(data, "Exchange", EXCHANGE.TSE.id),
        SecurityType: get(data, "SecurityType", SECURITY_TYPE.Equity.id),
      })
      if (get(symbolData, "Result") === 0) {
        const dispatchParams: {
          type: "REDUX_SYMBOL_DETAIL_SHOW_SYMBOL"
          data: APIResponse.Res
          tab?: number
        } = {
          type: REDUX_SYMBOL_DETAIL_SHOW_SYMBOL,
          data: symbolData,
        }
        if (!!tab) dispatchParams.tab = tab

        dispatch(dispatchParams)
        dispatch({
          type: API_MESSAGE,
          value: symbolData.Symbol,
        })
        dispatch({
          type: REDUX_SYMBOL_DETAIL_LOADING,
        })
        if (callRegulation) {
          dispatch({
            type: REDUX_SYMBOL_DETAIL_CALL_REGULATION,
          })
        }
        if (refresh) {
          dispatch({
            type: REDUX_SYMBOL_DETAIL_REFRESH,
          })
        }
      } else if (get(symbolData, "Result") === 3) {
        store.dispatch(
          setToastData({
            bodyMessage: "無効な銘柄です",
          })
        )
        dispatch({
          type: REDUX_SYMBOL_DETAIL_LOADING,
        })
      } else {
        dispatch({
          type: REDUX_SYMBOL_DETAIL_LOADING,
        })
      }
    }
  }
}

export const hideSymbol = () => {
  return {
    type: REDUX_SYMBOL_DETAIL_HIDE_SYMBOL,
  }
}

export const refreshSymbol = () => {
  return {
    type: REDUX_SYMBOL_DETAIL_REFRESH,
  }
}

/************************************
 * REDUCER
 ************************************/
const initialState: ReduxSymbolDetailStateType = {
  loading: false,
  show: false,
  callRegulation: false,
  refresh: false,
  tab: 0,
  data: {
    Symbol: {},
  },
}

export default (
  state: ReduxSymbolDetailStateType = initialState,
  action: ReduxSymbolDetailActionType
) => {
  switch (action.type) {
    case REDUX_SYMBOL_DETAIL_SHOW_SYMBOL:
      UserStorage.symbolDetail.set({
        ...state,
        show: true,
        data: action.data,
        tab: action.tab !== undefined ? action.tab : 0,
      })
      return {
        ...state,
        show: true,
        data: action.data,
        tab: action.tab !== undefined ? action.tab : 0,
      }
    case REDUX_SYMBOL_DETAIL_HIDE_SYMBOL:
      UserStorage.symbolDetail.set({
        ...state,
        show: false,
        tab: 0,
        data: {},
      })
      return {
        ...state,
        show: false,
        tab: 0,
        data: {},
      }
    case REDUX_SYMBOL_DETAIL_LOADING:
      UserStorage.symbolDetail.set({
        ...state,
        loading: !state.loading,
      })
      return {
        ...state,
        loading: !state.loading,
      }
    case REDUX_SYMBOL_DETAIL_CALL_REGULATION:
      UserStorage.symbolDetail.set({
        ...state,
        callRegulation: !state.callRegulation,
      })
      return {
        ...state,
        callRegulation: !state.callRegulation,
      }
    case REDUX_SYMBOL_DETAIL_REFRESH:
      return {
        ...state,
        refresh: !state.refresh,
      }
    default:
      return state
  }
}

/************************************
 * Util Function
 ************************************/
//sp用に右クリックで銘柄詳細が開くように分かれるための関数
export const requestSymbol = (data: object, fn: Function) => {
  const isPhone = checkIsSp()
  if (isPhone) {
    store.dispatch(showSymbol(data))
  } else {
    fn()
  }
}
